import React from 'react';
import { Box, Chip, Typography } from '@mui/material';




const ReadingBar = ({ startPosition, endPosition, totalConsumption, prorationPosition, prorationType }) => {
    const width = endPosition - startPosition;
    return (

        
        <Box
            sx={{
                left: `${startPosition}px`,
                width: `${width}px`,
            }}
        >
            <Chip
                sx={{
                    width: '100%',
                    backgroundColor: '#90caf9',
                    display: 'flex',
                    alignItems: 'center',
                    color: 'white',
                    px: 1,
                }}
                label={
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            px: 1,
                        }}
                    >
                        <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                            {totalConsumption} kWh
                        </Typography>
                    </Box>
                }
            />
        </Box>
    )

};

export default ReadingBar;
